import apiCore from '../../utils/api-core';

export function createContact(body) {
	return apiCore.post(`/api/v1/contacts`, body);
}

export function getContactsByBot(botId) {
	return apiCore.get(`/api/v1/contacts/bots/${botId}`);
}

export function getCompanyContactsByMobile(mobile) {
	return apiCore.get(`/api/v1/contacts/mobile-search/${mobile}`);
}

export function getContactDetails(contactId) {
	return apiCore.get(`/api/v1/contacts/${contactId}/contact-details`);
}

export function getContactByCompany(companyId, paginate, filters) {
	return apiCore.get(`/api/v1/companies/${companyId}/${paginate}/${filters}/contacts`);
}

export function getContactByCompanyDepartment(companyId, paginate, departmentIds, filters) {
	return apiCore.get(`/api/v1/companies/${companyId}/${paginate}/${departmentIds}/${filters}/contacts`);
}

export function getContactByCompanyMatch(companyId, paginate, distance, departmentIds, filters) {
	return apiCore.get(`/api/v1/companies/${companyId}/${paginate}/${distance}/${departmentIds}/${filters}/contacts`);
}

export function exportContacts() {
	return apiCore.get(`/api/v1/contacts/download`);
}

export function downloadContacts(fileName) {
	return apiCore.get(`/api/v1/files/contact/${fileName}`);
}

export function getContactByMobile(contactNumber) {
	return apiCore.get(`/api/v1/contacts/by-mobile/${contactNumber}`);
}

export function getContactGroupAsCsv(groupId) {
	return apiCore.get(`/api/v1/contacts/contact-group-csv/${groupId}`);
}

export function getContactsInGroup(groupId, paginate) {
	return apiCore.get(`/api/v1/groups/${groupId}/contacts/${paginate}`);
}

export function checkContactsInGroup(data) {
	return apiCore.post(`/api/v1/groups/check-contacts`, data);
}

export function searchForContact(groupId, searchContact) {
	return apiCore.get(`/api/v1/contacts/group/${groupId}/search/${searchContact}`);
}

export function importContacts(data) {
	return apiCore.post('/api/v1/contacts/import', data);
}

export function checkImportContacts(data) {
	return apiCore.post('/api/v1/contacts/check-import', data);
}

export function createMultipleContacts(data) {
	return apiCore.post('/api/v1/contacts/create-multiple-contacts', data);
}

export function searchContact(dat) {
	return apiCore.post(`/api/v1/contacts/search`, dat);
}

export function deleteContact(contactId) {
	return apiCore.delete(`/api/v1/contacts/delete/${contactId}`);
}

export function downloadContact(contactId){
	return apiCore.get(`/api/v3/contacts/${contactId}/pdf`);
}

export function updateMultipleContacts(data) {
	return apiCore.put('/api/v1/contacts/update-multiple-contacts', data);
}

export function checkCanSendNumber(number) {
	return apiCore.post('/api/v1/numbers/cansend',{mobile:number})
}

export function getCompanyContactsV3(companyId, params) {
    // Frontend fix: using GET with options for params
    return apiCore.get(`/api/v3/contacts/company/${companyId}`, { params });
}

export function createContactV3(data) {
    return apiCore.post('/api/v3/contacts', data);
}

export function deleteContactV3(contactId) {
    return apiCore.delete(`/api/v3/contacts/${contactId}`);
}

export function exportContactsV3(params) {
    return apiCore.get('/api/v3/contacts/export', { params });
}

export function importContactsExecuteV3(data) {
    return apiCore.post('/api/v3/contacts/import/execute', data);
}

export function getCompanyCustomContactFieldsV3() {
    return apiCore.get('/api/v3/contacts/custom-fields');
}